import {
  FormControl,
  FormDescription,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from '@/components/ui/form';
import {
  createFormControl,
  createRequiredRules,
  getPropertyType,
} from '@/pages/WorkflowsCatalog/components/run/controls/controls-factory';
import type { WorkflowDetail } from '@/pages/WorkflowsCatalog/types';
import type {
  ControllerRenderProps,
  FieldPath,
  FieldValues,
  Path,
  UseFormReturn,
} from 'react-hook-form';

type RunFormFieldProps<T extends FieldValues> = {
  fieldName: FieldPath<T>;
  property: any;
  workflow: WorkflowDetail;
  form: UseFormReturn<T>;
};

const RunFormField = <T extends FieldValues>({
  workflow,
  form,
  fieldName,
  property,
}: RunFormFieldProps<T>) => {
  const labelKey = fieldName.split('.').pop() || '';
  const isRequired = workflow.inputSchema.required?.includes(labelKey) ?? false;
  const propertyType = getPropertyType(property);

  const rules = createRequiredRules<T, Path<T>>(property, isRequired);

  return (
    <FormField
      control={form.control}
      name={fieldName}
      rules={rules}
      render={({ field }: { field: ControllerRenderProps<T, Path<T>> }) => (
        <FormItem>
          <FormLabel>
            {labelKey}
            {isRequired && <span className="text-destructive ml-1">*</span>}
          </FormLabel>
          <FormControl>{createFormControl({ field, property })}</FormControl>
          <FormDescription>{property.description || `${propertyType} type`}</FormDescription>
          <FormMessage />
        </FormItem>
      )}
    />
  );
};

export default RunFormField;
